import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { 
  Heart, 
  Users, 
  Globe, 
  Phone, 
  Mail, 
  MapPin,
  ArrowLeft
} from 'lucide-react';
import PadaidLogo from '../components/ui/PadaidLogo';
import SocialLoginButtons from '../components/auth/SocialLoginButtons';

const MobileApp = () => {
  const menuItems = [
    {
      id: 'blog',
      title: 'Blog',
      description: 'Derniers articles et actualités',
      icon: Globe,
      path: '/blog',
      color: 'from-blue-500 to-blue-600'
    },
    {
      id: 'gallery',
      title: 'Galerie',
      description: 'Photos de nos actions',
      icon: Users,
      path: '/gallery',
      color: 'from-green-500 to-green-600'
    },
    {
      id: 'membership',
      title: 'Adhésion',
      description: 'Rejoindre PADAID (9.99€ - 19.99€)',
      icon: Heart,
      path: '/payment-v2?package=member_monthly',
      color: 'from-purple-500 to-purple-600'
    },
    {
      id: 'donate',
      title: 'Faire un don',
      description: 'Soutenir nos actions',
      icon: Heart,
      path: '/payment-v2?package=donation_custom',
      color: 'from-red-500 to-red-600'
    },
    {
      id: 'contact',
      title: 'Contact',
      description: 'Nous contacter',
      icon: Phone,
      path: '/contact',
      color: 'from-yellow-500 to-yellow-600'
    }
  ];

  return (
    <div className="min-h-screen bg-gradient-to-br from-background via-background/90 to-primary/5">
      {/* Header */}
      <div className="sticky top-0 z-50 bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60 border-b border-border/40">
        <div className="container flex h-16 items-center justify-between">
          <Link to="/home" className="flex items-center space-x-2">
            <ArrowLeft className="h-5 w-5" />
            <span className="text-sm font-medium">Retour</span>
          </Link>
          <h1 className="text-lg font-bold">PADAID Mobile</h1>
          <div className="w-16" /> {/* Spacer */}
        </div>
      </div>

      <div className="container max-w-md mx-auto px-4 py-8">
        {/* Logo et bienvenue */}
        <div className="text-center mb-8">
          <div className="flex justify-center mb-4">
            <PadaidLogo size="lg" />
          </div>
          <h2 className="text-2xl font-bold mb-2">
            Bienvenue sur PADAID
          </h2>
          <p className="text-muted-foreground leading-relaxed">
            Rejoignez notre communauté engagée pour partager ce que nous avons acquis à ce que nous espérons.
          </p>
        </div>

        {/* Connexion sociale */}
        <Card className="mb-8">
          <CardHeader className="pb-4">
            <CardTitle className="text-center text-lg">Connexion rapide</CardTitle>
          </CardHeader>
          <CardContent>
            <SocialLoginButtons />
          </CardContent>
        </Card>

        {/* Menu principal */}
        <div className="space-y-4">
          <h3 className="text-lg font-semibold mb-4">Explorer</h3>
          
          {menuItems.map((item) => {
            const IconComponent = item.icon;
            return (
              <Card key={item.id} className="overflow-hidden">
                <CardContent className="p-0">
                  <Link
                    to={item.path}
                    className="flex items-center p-4 hover:bg-muted/50 transition-colors"
                  >
                    <div className={`p-3 rounded-lg bg-gradient-to-r ${item.color} mr-4`}>
                      <IconComponent className="h-6 w-6 text-white" />
                    </div>
                    <div className="flex-1">
                      <h4 className="font-semibold">{item.title}</h4>
                      <p className="text-sm text-muted-foreground">
                        {item.description}
                      </p>
                    </div>
                  </Link>
                </CardContent>
              </Card>
            );
          })}
        </div>

        {/* Contact rapide */}
        <Card className="mt-8">
          <CardHeader>
            <CardTitle className="text-center">Contact</CardTitle>
          </CardHeader>
          <CardContent className="space-y-3">
            <div className="flex items-center space-x-3 text-sm">
              <Mail className="h-4 w-4 text-muted-foreground" />
              <span>padaid.asso@gmail.com</span>
            </div>
            <div className="flex items-center space-x-3 text-sm">
              <MapPin className="h-4 w-4 text-muted-foreground" />
              <span>Paris, France</span>
            </div>
          </CardContent>
        </Card>

        {/* Footer */}
        <div className="text-center mt-8 pt-8 border-t border-border/50">
          <p className="text-xs text-muted-foreground">
            © {new Date().getFullYear()} PADAID. Tous droits réservés.
          </p>
          <p className="text-xs text-muted-foreground mt-1">
            Version mobile optimisée
          </p>
        </div>
      </div>
    </div>
  );
};

export default MobileApp;